module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingresult"
  }, [_c('label', {
    staticClass: "meetingresult__label"
  }, [_vm._v("Итоги встречи:")]), _c('Select')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9f73028","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/results/MentoringMeetingResult.vue
// module id = a6b9d2d89175614148bb
// module chunks = 89